import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import Graphics from './components/Graphics/Graphics';
import Volume from './components/Volume/Volume';
import Page from '../../components/Page/Page';
import ApiMServer from '../../services/ApiMServer';
import Reload from '../../components/reload/reload';
import Headers from '../../components/Headers/Headers';

const UnitsDetails = () => {
  const { id } = useParams();

  const [unit, setUnit] = useState({});
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const getCompany = async () => {
      try {
        const { data } = await ApiMServer.post('/company/detail', { id });
        setUnit(data)
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    getCompany();
  }, [id])

  return (
    <Page title={user?.hideSensitiveInfo ? "Unidade" : unit?.name || "Unidade"}>

      <Headers page={user?.hideSensitiveInfo ? "Unidade" : unit?.name || "Unidade"} />

      {loading && <Reload />}

      {!loading && unit?.equipments?.length === 0 && (
        <div className="d-flex justify-content-center mt-2">
          <Card className="text-center p-5 shadow-sm border-0" style={{ width: '100%', backgroundColor: '#f8f9fa' }}>
            <Card.Body>
              <div className="mb-3">
                <i className="fas fa-exclamation-circle fa-3x text-warning"></i>
              </div>
              <h4 className="text-dark mb-2">Nenhum equipamento encontrado</h4>
              <p className="text-muted mb-0">Não há equipamentos vinculados a esta unidade no momento.</p>
            </Card.Body>
          </Card>
        </div>
      )}

      {unit ? unit?.equipments?.length > 0 &&
        <Volume equipaments={unit.equipments} />
        : null}

      {unit && unit?.equipments?.length
        ? unit.equipments
          .filter(item =>
            item.includes("SIMT") ||
            item.includes("BIMT") ||
            item.includes("SEMT")
          )
          .map(item => (
            <Graphics key={item} equipaments={item} unit={unit} />
          ))
        : null}

    </Page>
  )
}
export default UnitsDetails;
